import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FileService } from "./file.service";
import { constants } from "../constants";
import { Shipment } from "../models/shipment.model";

@Injectable({ providedIn: 'root' })
export class ShipmentService {

    private static readonly SHIPMENT_URL = `${constants.BASE_URL}/shipments`;

    constructor(
        private http: HttpClient,
        private fileService: FileService
    ) { }

    getShipments(cpaId: string, startDate: string, endDate: string): Observable<Shipment[]> {
        return this.http.get<Shipment[]>(`${ShipmentService.SHIPMENT_URL}/${cpaId}/${startDate}/${endDate}`)
            .pipe(map((response: any[]) => response.map(shipment => new Shipment(shipment))));
    }

    exportShipments(cpaId: string, startDate: string, endDate: string): Observable<File> {
        return this.http.get(`${ShipmentService.SHIPMENT_URL}/export/${cpaId}/${startDate}/${endDate}`, { observe: 'response', responseType: 'blob' })
            .pipe(map((response: HttpResponse<Blob>) => this.fileService.createFileFromHttpResponse(response)));
    }

}